import React, { useEffect, useState, useRef } from "react";
import api from "../../api";

const LibraryAssignBooksPage = () => {
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [rolls, setRolls] = useState([]);
  const [student, setStudent] = useState(null);
  const [books, setBooks] = useState([]);
  const [issuedBooks, setIssuedBooks] = useState([]);
  const [finePerDay, setFinePerDay] = useState("");

  // 🔍 ফিল্টারের জন্য স্টেট
  const [statusFilter, setStatusFilter] = useState("issued"); 
  const [searchQuery, setSearchQuery] = useState(""); 

  // 📖 সার্চ বার ড্রপডাউনের জন্য স্টেট
  const [bookSearchQuery, setBookSearchQuery] = useState("");
  const [selectedBookName, setSelectedBookName] = useState(""); 
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null); 

  // 🔔 কাস্টম নোটিফিকেশন স্টেট
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    message: "",
    type: "success"
  });

  // ❓ কাস্টম কনফার্মেশন মডাল স্টেট
  const [confirmModal, setConfirmModal] = useState({
    show: false,
    issueId: null,
    studentName: "",
    bookName: ""
  });

  const today = new Date();
  const returnDate = new Date();
  returnDate.setDate(today.getDate() + 7);

  const [form, setForm] = useState({
    class_id: "",
    section_id: "",
    roll_no: "",
    student_id: "",
    book_id: "",
    issue_date: today.toISOString().split("T")[0],
    return_date: returnDate.toISOString().split("T")[0],
    remarks: ""
  });

  useEffect(() => {
    fetchBooks();
    fetchIssueList();
    fetchClasses();

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const showAlert = (message, type = "success") => {
    setAlertConfig({ show: true, message, type });
    setTimeout(() => {
      setAlertConfig({ show: false, message: "", type: "success" });
    }, 3000);
  };

  const fetchClasses = async () => {
    try {
      const res = await api.get("/get-classes");
      if (res.data?.success) {
        setClasses(res.data.data || []);
      } else {
        setClasses([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchSections = async (classId) => {
    try {
      const res = await api.get(`/get-sections/${classId}`);
      if (res.data?.success) {
        setSections(res.data.data || []);
      } else {
        setSections([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchRolls = async (sectionId) => {
    try {
      const res = await api.get(`/get-rolls/${sectionId}`);
      const rollData = res.data?.data || [];
      
      const uniqueRolls = [];
      const seenRolls = new Set();
      
      rollData.forEach(item => {
        if (!seenRolls.has(item.roll_no)) {
          seenRolls.add(item.roll_no);
          uniqueRolls.push(item);
        }
      });

      setRolls(uniqueRolls);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchBooks = async () => {
    try {
      const res = await api.get("/library/book/list");
      setBooks(res.data?.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchIssueList = async () => {
    try {
      const res = await api.get("/library/issue/list");
      setIssuedBooks(res.data?.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });

    if (name === "class_id") {
      fetchSections(value);
      setSections([]);
      setRolls([]);
      setStudent(null);
    }
    if (name === "section_id") {
      fetchRolls(value);
      setRolls([]);
      setStudent(null);
    }
  };

  const handleRollChange = async (e) => {
    const rollNo = e.target.value;
    if (!rollNo) {
      setStudent(null);
      return;
    }
    try {
      const res = await api.get(
        `/search-student-all?class_id=${form.class_id}&section_id=${form.section_id}&roll_no=${rollNo}`
      );
      const studentData = res.data?.students?.[0];
      if (studentData) {
        setStudent(studentData);
        setForm((prev) => ({
          ...prev,
          roll_no: rollNo,
          student_id: studentData.id
        }));
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleBookSelect = (book) => {
    setForm({ ...form, book_id: book.id });
    setSelectedBookName(book.book_name);
    setBookSearchQuery(book.book_name); 
    setIsDropdownOpen(false); 
  };

  const issueBook = async (e) => {
    e.preventDefault();

    // 🛑 ভ্যালিডেশন মেসেজ থেকে ডাবল আইকন সমস্যা ফিক্স করা হয়েছে
    if (!form.class_id) {
      showAlert("Please select a Class.", "warning");
      return;
    }
    if (!form.section_id) {
      showAlert("Please select a Section.", "warning");
      return;
    }
    if (!form.roll_no || !form.student_id) {
      showAlert("Please select a valid Roll No.", "warning");
      return;
    }
    if (!form.book_id) {
      showAlert("Please search and select a book from the list.", "warning");
      return;
    }
    if (!form.issue_date) {
      showAlert("Issue Date is required.", "warning");
      return;
    }
    if (!form.return_date) {
      showAlert("Return Date is required.", "warning");
      return;
    }

    try {
      await api.post("/library/issue/add", {
        ...form,
        fine_per_day: finePerDay || 0
      });
      
      showAlert("Book Issued Successfully!", "success");

      setForm({
        class_id: "",
        section_id: "",
        student_id: "",
        roll_no: "",
        book_id: "",
        issue_date: today.toISOString().split("T")[0],
        return_date: returnDate.toISOString().split("T")[0],
        remarks: ""
      });
      setFinePerDay("");
      setStudent(null);
      setBookSearchQuery("");
      setSelectedBookName("");
      fetchIssueList();
    } catch (err) {
      console.log(err);
      showAlert("Something went wrong. Please try again.", "error");
    }
  };

  const handleReturnClick = (id, studentName, bookName) => {
    setConfirmModal({
      show: true,
      issueId: id,
      studentName,
      bookName
    });
  };

  const handleConfirmReturn = async () => {
    const id = confirmModal.issueId;
    setConfirmModal({ show: false, issueId: null, studentName: "", bookName: "" });

    try {
      await api.post("/library/issue/return", { id });
      showAlert("Book Returned Successfully!", "success");
      fetchIssueList();
    } catch (err) {
      console.log(err);
      showAlert("Failed to return book.", "error");
    }
  };

  const filteredIssuedBooks = issuedBooks.filter((item) => {
    const matchesStatus = statusFilter === "all" || item.status === statusFilter;
    const cleanQuery = searchQuery.toLowerCase().trim();
    const matchesSearch = cleanQuery === "" || 
      (item.student_name && item.student_name.toLowerCase().includes(cleanQuery)) ||
      (item.student_code && item.student_code.toLowerCase().includes(cleanQuery));

    return matchesStatus && matchesSearch;
  });

  const filteredBooks = books.filter((book) => {
    const query = bookSearchQuery.toLowerCase().trim();
    if (selectedBookName && query === selectedBookName.toLowerCase()) return true;
    
    return (
      book.book_name?.toLowerCase().includes(query) ||
      book.author?.toLowerCase().includes(query) ||
      book.isbn?.toLowerCase().includes(query)
    );
  });

  return (
    <div style={styles.container}>
      <style>{hoverAndAnimationStyles}</style>

      {/* 🔔 কাস্টম টোস্ট অ্যালার্ট */}
      {alertConfig.show && (
        <div
          style={{
            ...styles.popupContainer,
            backgroundColor: alertConfig.type === "success" ? "#dcfce7" : (alertConfig.type === "warning" ? "#fef3c7" : "#fee2e2"),
            border: alertConfig.type === "success" ? "1px solid #22c55e" : (alertConfig.type === "warning" ? "1px solid #f59e0b" : "1px solid #ef4444"),
          }}
          className="popup-animation"
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span style={{ fontSize: "18px" }}>
              {alertConfig.type === "success" ? "⭐" : (alertConfig.type === "warning" ? "⚠️" : "❌")}
            </span>
            <span style={{ color: alertConfig.type === "success" ? "#14532d" : (alertConfig.type === "warning" ? "#78350f" : "#7f1d1d"), fontWeight: "600", fontSize: "14px" }}>
              {alertConfig.message}
            </span>
          </div>
        </div>
      )}

      {/* ❓ কাস্টম কনফার্মেশন মডাল */}
      {confirmModal.show && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent} className="modal-animation">
            <div style={styles.modalIconContainer}>📖</div>
            <h3 style={styles.modalTitle}>Confirm Book Return</h3>
            <p style={styles.modalText}>
              Are you sure you want to process the return of <strong style={{color: '#0f172a'}}>"{confirmModal.bookName}"</strong> issued to <strong style={{color: '#2563eb'}}>{confirmModal.studentName}</strong>?
            </p>
            <div style={styles.modalActionRow}>
              <button 
                onClick={() => setConfirmModal({ show: false, issueId: null, studentName: "", bookName: "" })}
                style={styles.btnModalCancel}
              >
                Cancel
              </button>
              <button 
                onClick={handleConfirmReturn}
                style={styles.btnModalConfirm}
              >
                Yes, Return It
              </button>
            </div>
          </div>
        </div>
      )}

      <h2 style={styles.heading}>📖 Assign Library Books</h2>
      <hr style={styles.hr} />

      {/* ফর্ম কার্ড */}
      <div style={styles.card}>
        <h4 style={styles.subHeading}>Issue Book Form</h4>
        <form onSubmit={issueBook} noValidate>
          <div style={styles.gridForm}>
            {/* ❌ সব লেবেল থেকে লাল স্টার মার্ক (*) সরিয়ে দেওয়া হয়েছে */}
            <div style={styles.formGroup}>
              <label style={styles.label}>Class</label>
              <select name="class_id" value={form.class_id} onChange={handleChange} style={styles.select} className="styled-input">
                <option value="">Select Class</option>
                {Array.isArray(classes) && classes.map((item) => (
                  <option key={item.id} value={item.id}>{item.class_name}</option>
                ))}
              </select>
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Section</label>
              <select name="section_id" value={form.section_id} onChange={handleChange} style={styles.select} className="styled-input">
                <option value="">Select Section</option>
                {sections.map((item) => (
                  <option key={item.id} value={item.id}>{item.section_name}</option>
                ))}
              </select>
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Roll No</label>
              <select value={form.roll_no} onChange={handleRollChange} style={styles.select} className="styled-input">
                <option value="">Select Roll</option>
                {Array.isArray(rolls) && rolls.map((item) => (
                  <option key={item.id} value={item.roll_no}>{item.roll_no}</option>
                ))}
              </select>
            </div>
          </div>

          {student && (
            <div style={styles.studentCard} className="fade-in">
              <h5 style={styles.studentCardTitle}>🎓 Student Information</h5>
              <div style={styles.studentCardBody}>
                <p style={styles.studentText}><strong>Name:</strong> {student.name}</p>
                <p style={styles.studentText}><strong>Student Code:</strong> {student.student_code}</p>
              </div>
            </div>
          )}

          <div style={styles.gridForm}>
            <div style={{ ...styles.formGroup, position: "relative" }} ref={dropdownRef}>
              <label style={styles.label}>Search & Select Book</label>
              <div style={styles.searchWrapper}>
                <input 
                  type="text" 
                  placeholder="🔍 Type book name, author, or ISBN..." 
                  value={bookSearchQuery}
                  onChange={(e) => {
                    setBookSearchQuery(e.target.value);
                    setIsDropdownOpen(true);
                    if(!e.target.value) setForm({...form, book_id: ""});
                  }}
                  onFocus={() => setIsDropdownOpen(true)}
                  style={styles.bookSearchInput}
                  className="styled-input"
                />
                {bookSearchQuery && (
                  <button 
                    type="button" 
                    onClick={() => { setBookSearchQuery(""); setSelectedBookName(""); setForm({...form, book_id: ""}); }} 
                    style={styles.clearSearchBtn}
                  >
                    ✕
                  </button>
                )}
              </div>

              {isDropdownOpen && (
                <div style={styles.dropdownList} className="fade-in">
                  {filteredBooks.length === 0 ? (
                    <div style={styles.dropdownNoResult}>No books found 😕</div>
                  ) : (
                    filteredBooks.map((item) => (
                      <div 
                        key={item.id} 
                        onClick={() => handleBookSelect(item)}
                        style={{
                          ...styles.dropdownItem,
                          backgroundColor: form.book_id === item.id ? "#eff6ff" : "transparent",
                          fontWeight: form.book_id === item.id ? "600" : "normal"
                        }}
                        className="dropdown-item-hover"
                      >
                        <div style={{ color: "#0f172a", fontSize: "14px" }}>{item.book_name}</div>
                        <div style={{ color: "#64748b", fontSize: "12px", marginTop: "2px" }}>
                          {item.author ? `Author: ${item.author}` : ""} {item.isbn ? ` | ISBN: ${item.isbn}` : ""}
                        </div>
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Issue Date</label>
              <input type="date" name="issue_date" value={form.issue_date} onChange={handleChange} style={styles.input} className="styled-input" />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Return Date</label>
              <input type="date" name="return_date" value={form.return_date} onChange={handleChange} style={styles.input} className="styled-input" />
            </div>
          </div>

          <div style={styles.gridForm}>
            <div style={{ ...styles.formGroup, gridColumn: "span 2" }}>
              <label style={styles.label}>Remarks (Optional)</label>
              <input type="text" name="remarks" value={form.remarks} onChange={handleChange} placeholder="Any special notes..." style={styles.input} className="styled-input" />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Fine Per Day (Optional)</label>
              <input type="number" value={finePerDay} onChange={(e) => setFinePerDay(e.target.value)} placeholder="e.g. 10" style={styles.input} className="styled-input" />
            </div>
          </div>

          <button type="submit" style={styles.btnPrimary} className="btn-primary-hover">⚡ Issue Selected Book</button>
        </form>
      </div>

      <hr style={styles.hr} />

      {/* হিস্টোরি টেবিল সেকশন */}
      <div style={styles.listHeaderRow}>
        <h3 style={styles.listHeading}>📋 Issued Books History</h3>
        <div style={styles.filtersContainer}>
          <div style={styles.filterGroup}>
            <input type="text" placeholder="Search by Student Name / Code..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} style={styles.searchBarInput} className="styled-input" />
          </div>
          <div style={styles.filterGroup}>
            <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} style={styles.filterSelect} className="styled-input">
              <option value="issued">Issued (Not Returned)</option>
              <option value="returned">Returned Books</option>
              <option value="all">All Books History</option>
            </select>
          </div>
        </div>
      </div>
      
      <div style={styles.tableResponsive}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>ID</th>
              <th style={styles.th}>Student Details</th>
              <th style={styles.th}>Class/Sec</th>
              <th style={styles.th}>Book Name</th>
              <th style={styles.th}>Issue Date</th>
              <th style={styles.th}>Return Date</th>
              <th style={styles.th}>Late Days</th>
              <th style={styles.th}>Current Fine</th>
              <th style={styles.th}>Status</th>
              <th style={styles.th}>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredIssuedBooks.length === 0 ? (
              <tr>
                <td colSpan="10" style={{ ...styles.td, textAlign: "center", color: "#888" }}>No records found matching your search criteria.</td>
              </tr>
            ) : (
              filteredIssuedBooks.map((item) => (
                <tr key={item.id} className="table-row-hover">
                  <td style={styles.td}>{item.id}</td>
                  <td style={styles.td}>
                    <div style={{ fontWeight: "600", color: "#1e293b" }}>{item.student_name}</div>
                    <div style={{ fontSize: "12px", color: "#64748b" }}>Code: {item.student_code}</div>
                  </td>
                  <td style={styles.td}>{item.class_name} ({item.section_name}) - Roll: {item.roll_no}</td>
                  <td style={{ ...styles.td, fontWeight: "500" }}>{item.book_name}</td>
                  <td style={styles.td}>{item.issue_date}</td>
                  <td style={styles.td}>{item.return_date}</td>
                  <td style={{ ...styles.td, color: item.late_days > 0 ? "#ef4444" : "#334155" }}>{item.late_days}</td>
                  <td style={{ ...styles.td, fontWeight: "600", color: item.current_fine > 0 ? "#ef4444" : "#22c55e" }}>₹ {item.current_fine}</td>
                  <td style={styles.td}>
                    <span style={item.status === "issued" ? styles.badgeIssued : styles.badgeReturned}>
                      {item.status === "issued" ? "Issued" : "Returned"}
                    </span>
                  </td>
                  <td style={styles.td}>
                    {item.status === "issued" ? (
                      <button
                        onClick={() => handleReturnClick(item.id, item.student_name, item.book_name)}
                        style={styles.btnAction}
                        className="btn-action-hover"
                      >
                        Return
                      </button>
                    ) : (
                      <span style={{ color: "#94a3b8", fontSize: "14px" }}>Completed</span>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const styles = {
  container: { maxWidth: "1240px", margin: "40px auto", padding: "0 24px", fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif", backgroundColor: "#f8fafc", color: "#334155", position: "relative" },
  modalOverlay: { position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(15, 23, 42, 0.6)", backdropFilter: "blur(4px)", zIndex: 10000, display: "flex", justifyContent: "center", alignItems: "center" },
  modalContent: { backgroundColor: "#ffffff", padding: "32px", borderRadius: "16px", width: "440px", maxWidth: "90%", textAlign: "center", boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)" },
  modalIconContainer: { width: "60px", height: "60px", backgroundColor: "#eff6ff", color: "#2563eb", fontSize: "28px", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center", margin: "0 auto 16px auto" },
  modalTitle: { fontSize: "20px", fontWeight: "700", color: "#0f172a", margin: "0 0 12px 0" },
  modalText: { fontSize: "15px", color: "#475569", lineHeight: "1.5", margin: "0 0 24px 0" },
  modalActionRow: { display: "flex", gap: "12px", justifyContent: "center" },
  btnModalCancel: { padding: "10px 20px", fontSize: "14px", fontWeight: "600", color: "#64748b", backgroundColor: "#f1f5f9", border: "none", borderRadius: "8px", cursor: "pointer", transition: "all 0.2s" },
  btnModalConfirm: { padding: "10px 20px", fontSize: "14px", fontWeight: "600", color: "#ffffff", backgroundColor: "#2563eb", border: "none", borderRadius: "8px", cursor: "pointer", transition: "all 0.2s", boxShadow: "0 4px 6px -1px rgba(37, 99, 235, 0.2)" },
  
  popupContainer: { position: "fixed", top: "24px", right: "24px", zIndex: 9999, padding: "14px 20px", borderRadius: "8px", boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)", display: "flex", alignItems: "center", minWidth: "250px" },
  
  heading: { fontSize: "26px", fontWeight: "700", color: "#0f172a", marginBottom: "10px" },
  listHeaderRow: { display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "16px", marginBottom: "20px" },
  listHeading: { fontSize: "20px", fontWeight: "600", color: "#1e293b", margin: 0 },
  filtersContainer: { display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" },
  filterGroup: { display: "flex", flexDirection: "column" },
  searchBarInput: { padding: "9px 14px", fontSize: "14px", borderRadius: "8px", border: "1px solid #cbd5e1", outline: "none", minWidth: "240px" },
  filterSelect: { padding: "9px 14px", fontSize: "14px", borderRadius: "8px", border: "1px solid #cbd5e1", outline: "none", backgroundColor: "#fff", cursor: "pointer", minWidth: "180px" },
  subHeading: { fontSize: "18px", fontWeight: "600", color: "#334155", marginBottom: "18px" },
  hr: { border: "0", height: "1px", background: "#e2e8f0", margin: "25px 0" },
  card: { background: "#ffffff", padding: "26px", borderRadius: "12px", boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)", border: "1px solid #e2e8f0" },
  gridForm: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "20px", marginBottom: "10px" },
  formGroup: { marginBottom: "16px", display: "flex", flexDirection: "column" },
  label: { fontSize: "14px", fontWeight: "600", color: "#475569", marginBottom: "6px" },
  input: { padding: "10px 14px", fontSize: "15px", borderRadius: "8px", border: "1px solid #cbd5e1", outline: "none", width: "100%", boxSizing: "border-box" },
  
  searchWrapper: { position: "relative", display: "flex", alignItems: "center" },
  bookSearchInput: { padding: "10px 40px 10px 14px", fontSize: "15px", borderRadius: "8px", border: "1px solid #cbd5e1", outline: "none", width: "100%", boxSizing: "border-box" },
  clearSearchBtn: { position: "absolute", right: "12px", background: "transparent", border: "none", color: "#94a3b8", cursor: "pointer", fontSize: "14px", padding: 0 },
  dropdownList: { position: "absolute", top: "100%", left: 0, right: 0, backgroundColor: "#ffffff", border: "1px solid #e2e8f0", borderRadius: "8px", boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)", zIndex: 99, maxHeight: "220px", overflowY: "auto", marginTop: "4px" },
  dropdownItem: { padding: "10px 14px", cursor: "pointer", borderBottom: "1px solid #f1f5f9", transition: "background-color 0.2s" },
  dropdownNoResult: { padding: "14px", color: "#64748b", fontSize: "14px", textAlign: "center" },

  select: { padding: "10px 14px", fontSize: "15px", borderRadius: "8px", border: "1px solid #cbd5e1", outline: "none", backgroundColor: "#fff", width: "100%", cursor: "pointer" },
  studentCard: { backgroundColor: "#eff6ff", border: "1px solid #bfdbfe", padding: "16px", borderRadius: "8px", marginBottom: "20px" },
  studentCardTitle: { margin: "0 0 10px 0", color: "#1e40af", fontSize: "15px", fontWeight: "600" },
  studentCardBody: { display: "flex", gap: "40px", flexWrap: "wrap" },
  studentText: { margin: "0", fontSize: "14px", color: "#1e3a8a" },
  btnPrimary: { backgroundColor: "#2563eb", color: "#ffffff", padding: "12px 24px", fontSize: "15px", fontWeight: "600", border: "none", borderRadius: "8px", cursor: "pointer", marginTop: "10px", width: "100%" },
  btnAction: { backgroundColor: "#f43f5e", color: "#ffffff", padding: "6px 14px", fontSize: "13px", fontWeight: "500", border: "none", borderRadius: "6px", cursor: "pointer" },
  tableResponsive: { overflowX: "auto", backgroundColor: "#ffffff", borderRadius: "12px", boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)", border: "1px solid #e2e8f0" },
  table: { width: "100%", borderCollapse: "collapse", textAlign: "left", fontSize: "14px" },
  th: { backgroundColor: "#f8fafc", color: "#475569", fontWeight: "600", padding: "14px 16px", borderBottom: "2px solid #e2e8f0" },
  td: { padding: "14px 16px", borderBottom: "1px solid #f1f5f9", color: "#334155" },
  badgeIssued: { backgroundColor: "#fee2e2", color: "#ef4444", padding: "4px 8px", borderRadius: "6px", fontSize: "12px", fontWeight: "600" },
  badgeReturned: { backgroundColor: "#dcfce7", color: "#22c55e", padding: "4px 8px", borderRadius: "6px", fontSize: "12px", fontWeight: "600" }
};

const hoverAndAnimationStyles = `
  .styled-input:focus {
    border-color: #2563eb !important;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
  }
  .dropdown-item-hover:hover {
    background-color: #f1f5f9 !important;
  }
  .btn-primary-hover:hover {
    background-color: #1d4ed8 !important;
    transform: translateY(-1px);
  }
  .btn-action-hover:hover {
    background-color: #e11d48 !important;
  }
  .table-row-hover:hover {
    background-color: #f8fafc;
  }
  .fade-in {
    animation: fadeIn 0.2s ease-in-out;
  }
  .popup-animation {
    animation: slideIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }
  .modal-animation {
    animation: modalScale 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-4px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes slideIn {
    from { opacity: 0; transform: translateY(-15px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes modalScale {
    from { opacity: 0; transform: scale(0.9); }
    to { opacity: 1; transform: scale(1); }
  }
`;

export default LibraryAssignBooksPage;